export default __webpack_public_path__ + "static/media/AppleLogo.019cde9a.svg";